module.exports = __webpack_public_path__ + "img/intel.053def36.jpg";